import React from 'react';
import styled from 'styled-components';
import { TrueImpactFile } from './TrueImpactFileUploadBox';
import { SPACERS } from '../settings/variables/Spacers';

interface FileErrorProps {
  file: TrueImpactFile | undefined;
}

const StyledDiv = styled.div`
  .token-error {
    margin-bottom: ${SPACERS.tiny};
  }
`;

const apiError = 'Token is expired';
const errorText = (
  <div className="token-error">
    Looks like you were away for a while.
    <br />
    Please try again by refreshing the page.
  </div>
);

const FileError: React.FC<FileErrorProps> = ({ file }) => {
  if (!file) return null;
  if (file.error === apiError || file.error?.includes('401')) {
    return <StyledDiv>{errorText}</StyledDiv>;
  }
  return <StyledDiv>{file.error}</StyledDiv>;
};

export default FileError;
